<template>
    <div class="benefits">
        <b-skeleton-wrapper :loading="!homeSection.exists">
            <template #loading>
                <b-skeleton
                    width="85%"
                    class="my-2"
                />
                <b-skeleton
                    width="55%"
                    class="my-2"
                />
                <b-skeleton
                    width="70%"
                    class="my-2"
                />
            </template>

            <template v-for="(benefit, index) in homeSection.benefits">
                <b-row
                    v-if="benefit.status"
                    :key="index"
                    align-v="center"
                    class="my-2"
                >
                    <b-col class="d-flex">
                        <i class="fas fa-check mr-3 mt-1"></i>

                        <p class="text mb-0">
                            {{ benefit.value }}
                        </p>
                    </b-col>
                </b-row>
            </template>
        </b-skeleton-wrapper>
    </div>
</template>

<script>
    import './Benefits.scss';
    import LandingPageHomeSectionAppResource
        from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageHomeSectionAppResource";

    export default {
        name: "Benefits",
        props: {
            homeSection: {
                type: LandingPageHomeSectionAppResource,
                required: true,
            }
        }
    };
</script>
